import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({ baseURL: API });

// Attach admin token automatically if present
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("beh_admin_token");
  if (token && config.url?.startsWith("/admin")) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export async function getTours(params = {}) {
  const { data } = await apiClient.get("/tours", { params });
  return data;
}

export async function getTour(slug) {
  const { data } = await apiClient.get(`/tours/${slug}`);
  return data;
}

export async function getRegionCounts() {
  const { data } = await apiClient.get("/meta/regions");
  return data;
}

export async function createEnquiry(payload) {
  const { data } = await apiClient.post("/enquiries", payload);
  return data;
}


export async function getPaymentStatus() {
  const { data } = await apiClient.get("/payments/status", { timeout: 10000 });
  return data;
}

export async function createItineraryRequest(payload) {
  const { data } = await apiClient.post("/itinerary-requests", payload, { timeout: 20000 });
  return data;
}


export async function createPaymentOrder(payload) {
  const { data } = await apiClient.post("/payments/create-order", payload);
  return data;
}

export async function verifyPayment(payload) {
  const { data } = await apiClient.post("/payments/verify", payload);
  return data;
}

export async function adminLogin(username, password) {
  const { data } = await apiClient.post("/admin/login", { username, password });
  return data;
}

export async function adminMe() {
  const { data } = await apiClient.get("/admin/me");
  return data;
}

export async function adminListEnquiries(params = {}) {
  const { data } = await apiClient.get("/admin/enquiries", { params });
  return data;
}

export async function adminEnquiryStats() {
  const { data } = await apiClient.get("/admin/enquiries/stats");
  return data;
}

export async function adminUpdateEnquiryStatus(id, lead_status) {
  const { data } = await apiClient.patch(`/admin/enquiries/${id}`, { lead_status });
  return data;
}
